import * as Sentry from "@sentry/react";
import { ReactBrowserLoggerEngine } from "./react-browser-logger-engine";
function ReactLoggerEngine(options) {
    return ReactBrowserLoggerEngine(options, Sentry);
}
export default ReactLoggerEngine;
const { ErrorBoundary, withSentryRouting, startTransaction, getCurrentHub } = Sentry;
export { ErrorBoundary, withSentryRouting, startTransaction, getCurrentHub };
//# sourceMappingURL=react-logger-engine.js.map